/**
 * Loading stuff
 */
export function serviceIsLoading(...services) {
    return !!services.find((s) => (s?.fetchRequested || s?.fetching) && !(serviceHasData(s) && s?.silentFetch));
}

export function serviceIsSilentlyLoading(...services) {
    return !!services.find((s) => (s?.fetchRequested || s?.fetching) && s?.silentFetch);
}

export function serviceIsLoadingInSomeWay(...services) {
    return serviceIsLoading(...services) || serviceIsSilentlyLoading(...services);
}

export function serviceIsLoadingOrNotFetched(...services) {
    return !!services.find((s) => serviceIsLoading(s) || !serviceIsFetched(s));
}

export function serviceIsLoadingOrFetched(...services) {
    return serviceIsLoading(...services) || serviceIsFetched(...services);
}

export function serviceIsLoadingOrSuccessfullyFetched(...services) {
    return serviceIsSuccessfullyFetched(...services);
}

export function getServiceLoaderInOrder(...services) {
    return {
        isServiceLoadingInOrder: (service) => {
            return services?.reduce((loading, s) => {
                if (loading === false) {
                    return false;
                }
                if (loading === true) {
                    return true;
                }
                if (s === service) {
                    return serviceIsLoading(service);
                }
                if (serviceIsLoading(s)) {
                    return true;
                }
                return null;
            }, null);
        },
        isServiceLoadedOrNotFetchedInOrder: (service) => {
            return services?.reduce((loading, s) => {
                if (loading === false) {
                    return false;
                }
                if (loading === true) {
                    return true;
                }
                if (s === service) {
                    return serviceIsLoadingOrNotFetched(service);
                }
                if (serviceIsLoadingOrNotFetched(s)) {
                    return true;
                }
                return null;
            }, null);
        },
        areAllServicesFetched: () => {
            return services?.reduce((fetched, s) => {
                if (fetched === false) {
                    return false;
                }
                return serviceIsFetched(s);
            }, true);
        },
        isServiceFetchedInOrder: (service) => {
            return services?.reduce((loading, s) => {
                if (loading === false) {
                    return false;
                }
                if (loading === true) {
                    return true;
                }
                if (s === service) {
                    return serviceIsFetched(service);
                }
                if (!serviceIsFetched(s)) {
                    return false;
                }
                return null;
            }, null);
        },
        services,
    };
}

/**
 * Error stuff
 */

export function serviceHasError(...services) {
    return !!services?.find((s) => getServiceError(s));
}

export function getServiceError(service) {
    return service?.error;
}

/**
 * Successful stuff
 */

export function serviceIsFetched(...services) {
    return !services?.find((s) => !s?.fetched);
}

export function serviceHasData(...services) {
    return !services.find((s) => !getServiceData(s));
}

export function getServiceData(service) {
    return service?.data;
}

export function serviceIsSuccessfullyFetched(...services) {
    const filterUndefinedServices = services?.filter((s) => s);

    return !!filterUndefinedServices && filterUndefinedServices.length > 0 && !filterUndefinedServices.find((s) => !serviceIsFetched(s) || serviceHasError(s));
}

/**
 * Response object functions
 */

export function isResponseCsv(response) {
    return response?.headers?.get("Content-Type")?.includes("csv");
}

export function getResponseFileName(response) {
    return response?.headers?.get("Turnr-Filename");
}

export function downloadCsvFromResponseObject(data, response) {
    const fileName = getResponseFileName(response) || "ingrid-returns-report.csv";

    var blob = new Blob([data], { type: "data:text/csv;charset=utf-8" });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement("a");
    pom.href = url;
    pom.setAttribute("download", fileName);
    pom.click();
}

/**
 * Other functions
 */

export function getServicedNrTimesFetched(service) {
    return service?.timesFetched;
}
